<template>
  <b-modal size="lg" v-model="show" centered title="Auftraggeber-/Rechnungsadresse"
  >
    <div  v-if="isAGeber">
      <b-row class="justify-content-md-center">
        <b-col style="padding: 40px;">
          <b-row>
            <b-col md="6">
              <h5>Auftraggeber</h5>
            </b-col>
            <b-col md="6">
              <b-button style="float: right;" variant="primary" size="sm" @click="toggleButton">
                abw. Rechn.-Empfänger
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <label for="anrede">Anrede</label>
              <b-form-select :options="anrede_select" id="anrede" :plain="true"
                             v-model="gi_anrede"
                             class="mb-2 text-black"
                             :disabled="!canEdit"
              ></b-form-select>
            </b-col>
          </b-row>
          <label for="name">Name 1</label>
          <b-form-input id="name" type="text"
                        v-model="gi_name1"
                        class="mb-2 text-black"
                        maxlength="30" :disabled="!canEdit"
          ></b-form-input>
          <b-form-text style="text-align: right">{{gi_name1.length}}/30</b-form-text>
          <label for="name">Name 2</label>
          <b-form-input id="name" type="text"
                        v-model="gi_name2"
                        class="mb-2 text-black"
                        maxlength="30" :disabled="!canEdit"
          ></b-form-input>
          <b-form-text style="text-align: right">{{gi_name2.length}}/30</b-form-text>
          <label for="str_hnr">Straße Hausnummer</label>
          <b-form-input id="str_hnr" type="text"
                        v-model="gi_strasse"
                        class="mb-2 text-black"
                        maxlength="30" :disabled="!canEdit"
          ></b-form-input>
          <b-form-text style="text-align: right">{{gi_strasse.length}}/30</b-form-text>
          <b-row>
            <b-col sm="4">
              <label for="plz">PLZ</label>
              <b-form-input id="plz" type="text"
                            v-model="gi_plz"
                            class="mb-2 text-black"
                            maxlength="5" :disabled="!canEdit"
              ></b-form-input>
              <b-form-text style="text-align: right">{{gi_plz.length}}/5</b-form-text>
            </b-col>
            <b-col sm="8">
              <label for="ort">Ort</label>
              <b-form-input id="ort" type="text"
                            v-model="gi_ort"
                            class="mb-2 text-black"
                            maxlength="30" :disabled="!canEdit"
              ></b-form-input>
              <b-form-text style="text-align: right">{{gi_ort.length}}/30</b-form-text>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div  v-else>
      <b-row class="justify-content-md-center">
        <b-col style="padding: 40px;">
          <b-row>
            <b-col md="6">
              <h5>Abweichender Rechnungsempfänger</h5>
            </b-col>
            <b-col md="6">
              <b-button style="float: right;" variant="primary" size="sm" @click="toggleButton">
                Auftraggeber
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <label for="anrede">Anrede</label>
              <b-form-select :options="anrede_select" id="anrede" :plain="true"
                             v-model="re_anrede" :disabled="!canEdit"
                             class="mb-2 text-black"></b-form-select>
            </b-col>
            <b-col sm="8">
              <label for="pk_nr">PK-Nr.</label>
              <b-form-input id="pk_nr" type="text"
                            v-model="renr" :disabled="!canEdit"
                            class="mb-2 text-black"
                            maxlength="20"
              ></b-form-input>
              <b-form-text style="text-align: right">{{renr.length}}/20</b-form-text>
            </b-col>
          </b-row>
          <label for="name">Name</label>
          <b-form-input id="name" type="text"
                        v-model="re_vorname" :disabled="!canEdit"
                        class="mb-2 text-black"
                        maxlength="60"
          ></b-form-input>
          <b-form-text style="text-align: right">{{re_vorname.length}}/60</b-form-text>

          <label for="name">zu Händen von</label>
          <b-form-input id="name" type="text"
                        v-model="re_name1" :disabled="!canEdit"
                        class="mb-2 text-black"
                        maxlength="60"
          ></b-form-input>
          <b-form-text style="text-align: right">{{re_name1.length}}/60</b-form-text>
          <label for="str_hnr">Straße Hausnummer</label>
          <b-form-input id="str_hnr" type="text"
                        v-model="re_str_hnr" :disabled="!canEdit"
                        class="mb-2 text-black"
                        maxlength="60"
          ></b-form-input>
          <b-form-text style="text-align: right">{{re_str_hnr.length}}/60</b-form-text>
          <b-row>
            <b-col sm="2">
              <label for="land">Ländercode</label>
              <b-form-input id="land" type="text"
                            v-model="re_land" :disabled="!canEdit"
                            class="mb-2 text-black"
                            placeholder="z.B. DE"
                            maxlength="3"
              ></b-form-input>
              <b-form-text style="text-align: right">{{re_land.length}}/3</b-form-text>
            </b-col>
            <b-col sm="2">
              <label for="plz">PLZ</label>
              <b-form-input id="plz" type="text"
                            v-model="re_plz" :disabled="!canEdit"
                            class="mb-2 text-black"
                            maxlength="5"
              ></b-form-input>
              <b-form-text style="text-align: right">{{re_plz.length}}/5</b-form-text>
            </b-col>
            <b-col sm="8">
              <label for="ort">Ort</label>
              <b-form-input id="ort" type="text"
                            v-model="re_ort" :disabled="!canEdit"
                            class="mb-2 text-black"
                            maxlength="80"
              ></b-form-input>
              <b-form-text style="text-align: right">{{re_ort.length}}/80</b-form-text>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button v-if="canEdit" size="md" variant="success" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {decryptAES, encryptAES} from "@/shared/crypto";
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";

export default {
  props: {
    addressData: Object,
    canEdit: Boolean,
    taskId: String
  },
  name: "AGeberDialog",
  data() {
    return {
      loader: undefined,
      show: false,
      anrede_select: ["Firma", "An den", "An die", "An das", "Herr", "Frau"],
      isAGeber: true,

      aufisn: '',
      a_geber: '',
      gi_anrede: '',
      gi_name1: '',
      gi_name2: '',
      gi_strasse: '',
      gi_plz: '',
      gi_ort: '',

      re_anrede: '',
      renr: '',
      re_vorname: '',
      re_name1: '',
      re_str_hnr: '',
      re_land: '',
      re_plz: '',
      re_ort: '',

    }
  },
  methods: {
    async showModal() {
      this.isAGeber = true;
      if (this.addressData.gi_name1 !== undefined) {
        this.gi_anrede = this.addressData.gi_anrede;
        try {
          this.gi_name1 = await decryptAES(sessionStorage.getItem("aes"), this.addressData.gi_name1)
        } catch (e) {
          this.gi_name1 = this.addressData.gi_name1
        }
        try {
          this.gi_name2 = await decryptAES(sessionStorage.getItem("aes"), this.addressData.gi_name2)
        } catch (e) {
          this.gi_name2 = this.addressData.gi_name2
        }
        try {
          this.gi_strasse = await decryptAES(sessionStorage.getItem("aes"), this.addressData.gi_strasse)
        } catch (e) {
          this.gi_strasse = this.addressData.gi_strasse
        }
        this.gi_plz = this.addressData.gi_plz
        this.gi_ort = this.addressData.gi_ort

        this.re_anrede = this.addressData.re_anrede;
        this.renr = this.addressData.renr;
        try {
          this.re_vorname = await decryptAES(sessionStorage.getItem("aes"), this.addressData.re_vorname)
        } catch (e) {
          this.re_vorname = this.addressData.re_vorname
        }
        try {
          this.re_name1 = await decryptAES(sessionStorage.getItem("aes"), this.addressData.re_name1)
        } catch (e) {
          this.re_name1 = this.addressData.re_name1
        }
        try {
          this.re_str_hnr = await decryptAES(sessionStorage.getItem("aes"), this.addressData.re_str_hnr)
        } catch (e) {
          this.re_str_hnr = this.addressData.re_str_hnr
        }
        this.re_land = this.addressData.re_land;
        this.re_plz = this.addressData.re_plz;
        this.re_ort = this.addressData.re_ort;
      }
      this.show = true;
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    getReturnData() {
      return {
        a_geber_data: {
          gi_anrede: this.gi_anrede,
          gi_name1: this.gi_name1,
          gi_name2: this.gi_name2,
          gi_strasse: this.gi_strasse,
          gi_plz: this.gi_plz,
          gi_ort: this.gi_ort,
        },
        invoice_data: {
          re_anrede: this.re_anrede,
          renr: this.renr,
          re_vorname: this.re_vorname,
          re_name1: this.re_name1,
          re_str_hnr: this.re_str_hnr,
          re_land: this.re_land,
          re_plz: this.re_plz,
          re_ort: this.re_ort,
        }
      };
    },
    toggleButton() {
      this.isAGeber = !this.isAGeber;
    },
    async onSave() {
      let data = this.getReturnData();
      if (!this.taskId) {
        this.show = false;
        this.$emit("a-geber-change", data);
        return;
      }
      this.showLoader()
      data.a_geber_data.gi_name1 = await encryptAES(sessionStorage.getItem("aes"), data.a_geber_data.gi_name1);
      data.a_geber_data.gi_name2 = await encryptAES(sessionStorage.getItem("aes"), data.a_geber_data.gi_name2);
      data.a_geber_data.gi_strasse = await encryptAES(sessionStorage.getItem("aes"), data.a_geber_data.gi_strasse);
      if (data.invoice_data.renr || data.invoice_data.re_vorname || data.invoice_data.re_name1 || data.invoice_data.re_str_hnr) {
        data.invoice_data.re_vorname = await encryptAES(sessionStorage.getItem("aes"), data.invoice_data.re_vorname);
        data.invoice_data.re_name1 = await encryptAES(sessionStorage.getItem("aes"), data.invoice_data.re_name1);
        data.invoice_data.re_str_hnr = await encryptAES(sessionStorage.getItem("aes"), data.invoice_data.re_str_hnr);
      }
      this.$http.post(
          Server_URL+'/auftragsbuch/data/address/'+this.taskId,
          data
      ).then(this.responseOk, this.responseError)
    },
    responseOk(response) {
      this.hideLoader();
      this.show = false;
      this.$emit("on-changed", this.getReturnData());
    },
    responseError(response) {
      this.hideLoader();
      this.show = false;
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },

    onCancel() {
      this.show = false;
    }
  }
}
</script>

<style scoped>
  .text-black {
    color: black;
  }
  .vld-overlay.is-full-page {
    z-index: 1600;
    position: fixed;
  }
</style>
